import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const { createContext, useState } = require('react');

const AuthContext = createContext();
export const AuthProvider = ({ children }: any) => {
    const userData: any = sessionStorage.getItem('user_data') ? sessionStorage.getItem('user_data') : '';
    const user_data: any = !window.cn(userData) ? JSON.parse(userData) : '';

    const [token, setToken] = useState(null);
    const [name, setName] = useState(null);
    const [role, setRole] = useState(null);
    const [userDetails, setUserDetails] = useState(user_data);
    const navigate = useNavigate();

    useEffect(() => {
        // setUserDetails(user_data);
        setToken(user_data?.token);
        setName(user_data?.first_name);
        setRole(user_data?.role_id);
    }, [user_data]);

    const saveInformation = (token: any, name: any, role: any) => {
        setToken(user_data?.token);
        setName(user_data?.first_name);
        setRole(user_data?.role);
    };

    const logout = () => {
        setName(null);
        setRole(null);
        setToken(null);
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
    };

    return (
        <>
            <AuthContext.Provider value={{ token, name, role, userDetails, saveInformation, logout }}>{children}</AuthContext.Provider>
        </>
    );
};

export default AuthContext;
